export default __webpack_public_path__ + "static/damage_void-4b44ab.svg";